import MapButton from "../map-button/MapButton";
import iconBack from "@/img/back-button-map-icon.svg";
import iconNext from "@/img/next-button-map-icon.svg";
import iconStart from "@/img/start-button-map-icon.svg";
import iconPause from "@/img/pause-icon.svg";

import "./style.scss";

type MapButtonContainerProps = {
	showButtonPause: boolean;
	prevDisabled: boolean;
	nextDisabled: boolean;
	isPlaying?: boolean;
	handleClickPrev: () => void;
	handleClickNext: () => void;
	handleClickPause?: () => void;
};

export const MapButtonContainer = ({
	prevDisabled,
	nextDisabled,
	showButtonPause,
	isPlaying,
	handleClickNext,
	handleClickPrev,
	handleClickPause,
}: MapButtonContainerProps) => {
	return (
		<div className="button-map-container">
			<MapButton
				isDisabled={prevDisabled}
				icon={<img src={iconBack} alt="back button maps"></img>}
				handleClick={() => handleClickPrev()}
			/>

			{showButtonPause && isPlaying !== undefined && handleClickPause && (
				<MapButton
					isDisabled={false}
					icon={
						<img
							src={isPlaying ? iconPause : iconStart}
							alt="control video"
						></img>
					}
					handleClick={() => handleClickPause()}
				/>
			)}

			<MapButton
				isDisabled={nextDisabled}
				icon={<img src={iconNext} alt="next button maps"></img>}
				handleClick={() => handleClickNext()}
			/>
		</div>
	);
};

export default MapButtonContainer;
